import React from 'react'

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  List,
  ListItem,
  ListItemText,
  ListSubheader,
} from '@mui/material'
import { useSelector } from 'react-redux'
import type { RootState } from 'reducers'

import { clearSelection } from 'actions/campaign-targets-actions'
import { useAddNotification } from 'hooks/useAddNotification'
import { useAppDispatch } from 'hooks/useAppDispatch'
import { useUpdateTargets } from 'hooks/useCampaignTargets'

type CampaignTargetsModalProps = {
  id: string
  open: boolean
  onClose: (...args: any[]) => any
}

const renderList = (header: string, data: any) => (
  <List dense subheader={<ListSubheader>{header}</ListSubheader>}>
    {data.toArray().map((item: any, index: number) => (
      <ListItem key={index}>
        <ListItemText primary={item} />
      </ListItem>
    ))}
  </List>
)

const CampaignTargetsModal = ({ id, open, onClose }: CampaignTargetsModalProps) => {
  const updates = useSelector((s: RootState) => s.campaignTargets.meta.get('updates'))
  const dispatch = useAppDispatch()
  const addNotification = useAddNotification()
  const { mutate, isPending } = useUpdateTargets(id)

  const handleSubmit = () =>
    mutate(updates, {
      onSuccess: () => {
        addNotification('Targets updated successfully', 'success')
        dispatch(clearSelection())
        onClose()
      },
      onError: () => addNotification('Error occurred when updating targets', 'error'),
    })

  return (
    <Dialog onClose={onClose} open={open}>
      <DialogTitle>Do you want to update these targets?</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} style={{ width: 600 }}>
          <Grid size={{ sm: 6 }}>{renderList('Paused', updates.get('paused'))}</Grid>
          <Grid size={{ sm: 6 }}>{renderList('Running', updates.get('running'))}</Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={onClose}>
          Cancel
        </Button>
        <Button color="primary" loading={isPending} onClick={handleSubmit}>
          Update
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default CampaignTargetsModal
